
import React, { useState, useMemo } from 'react';
import { Eye, Pencil, Download, X } from 'lucide-react';
import './dbtTable.scss';

const renderSkeletonRows = (count = 5) =>
  Array.from({ length: count }).map((_, i) => (
    <tr key={`sk-${i}`} className="skeleton-row">
      <td><span className="skeleton pill w-28" /></td>
      <td><span className="skeleton text w-44" /></td>
      <td><span className="skeleton text w-72" /></td>
      <td><span className="skeleton text w-40" /></td>
      <td><span className="skeleton text w-32" /></td>
      <td>
        <div className="action-buttons">
          <span className="skeleton icon" />
          <span className="skeleton icon" />
          <span className="skeleton icon" />
        </div>
      </td>
    </tr>
  ));

const DBTTable = ({ data, totalPages, currentPage, setCurrentPage, loading = false, handleViewClick, handleEditClick, totalCount = 0, pageSize = 10, handleCheckboxChange }) => {
  // Calculate result info
  const startIndex = totalCount > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endIndex = Math.min(currentPage * pageSize, totalCount);

  // Generate page numbers to display (max 3 pages)
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 3;
    let startPage = Math.max(1, currentPage - 1);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust start if we're near the end
    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="dbt-table-wrapper">
      <div className="table-container">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>DBT ID</th>
                <th>DBT Name</th>
                <th>Description</th>
                <th>Active Effective Period</th>
                {/* <th>Status</th> */}
                <th>Created By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                renderSkeletonRows(5)
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '2rem' }}>
                    No DBT Rules found
                  </td>
                </tr>
              ) : (
                data.map((row) => (
                  <tr key={row.id}>
                    <td className="id-cell">{row.id}</td>
                    <td className="name-cell">{row.name}</td>
                    <td className="description-cell">{row.description}</td>
                    <td className="period-cell">{row.period}</td>
                    {/* <td className="status-cell">{row?.status ? row.status : 'N/A'}</td> */}
                    <td className="created-by-cell">{row.createdBy}</td>
                    <td className="actions-cell">
                      <div className="action-buttons">
                        <button className="view-btn" aria-label="View" onClick={() => handleViewClick(row.id)}>
                          <Eye size={18} />
                        </button>
                        <button className="edit-btn" aria-label="Edit" onClick={() => handleEditClick(row.id)}>
                          <Pencil size={18} />
                        </button>
                        {/* <label className="switch">
                          <input type="checkbox" checked={row.is_active} onChange={(e) => handleCheckboxChange(row.id, e.target.checked)} />
                          <span className="slider round"></span>
                        </label> */}
                        {/* <button className="download-btn" aria-label="Download">
                          <Download size={18} />
                        </button> */}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="table-footer">
          {loading ? (
            <div className="footer-skeleton">
              <span className="skeleton text w-40" />
              <div className="pagination">
                <span className="skeleton pill w-16" />
                <span className="skeleton pill w-8" />
                <span className="skeleton pill w-8" />
                <span className="skeleton pill w-8" />
                <span className="skeleton pill w-16" />
              </div>
            </div>
          ) : (
            <>
              <div className="results-info">
                {totalCount > 0 ? `Showing ${startIndex} to ${endIndex} of ${totalCount} results` : 'No results'}
              </div>
              <div className="pagination">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className="prev-btn"
                >
                  Previous
                </button>
                {pageNumbers.map(pageNum => (
                  <button
                    key={pageNum}
                    onClick={() => setCurrentPage(pageNum)}
                    className={`page-btn ${currentPage === pageNum ? 'active' : ''}`}
                  >
                    {pageNum}
                  </button>
                ))}
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                  className="next-btn"
                >
                  Next
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DBTTable;
